var DateService = require('../services/date-service');
var StoreService = require('../services/store-service');

var dataLayer = window.dataLayer;

(function blzDataLayer() {
  'use strict';

  blz.dataLayer = blz.dataLayer || {};

  blz.dataLayer.templates = {
    BLZproductDetail: {
      event: 'BLZproductDetail',
      PageType: blz.pageType,
      ecommerce: {
        detail: {
          products: []
        }
      }
    },

    BLZpage: {
      event: 'BLZpage',
      PageType: blz.pageType
    }
  };

  function docReady(onReady) {
    if (document.readyState == 'complete') {
      onReady();
      return;
    }
    if (typeof window.addEventListener === 'function') {
      window.addEventListener('DOMContentLoaded', onReady, false);
    } else {
      blz.eventListener('load', onReady);
    }
  }

  if (document.body) {
    _render();
  } else {
    docReady(_render);
  }

  function _render() {
    'use strict';

    //Banner item
    [].slice.call(document.querySelectorAll('[data-banner]')).forEach(_bannerImpression);

    // Expose API
    blz.dataLayer.impressions = _impressions;

    _impressions();

    /*
     * Impressions
     */
    function _impressions(tabName, elementsData) {
      var elements = elementsData || document.querySelectorAll('[data-layer]'),
        config = {},
        objs = {},
        dataLayerEvent = '',
        listName = StoreService.slugify(tabName || '');

      if (!elements.length) {
        return false;
      }

      // Create clone of templates
      for (var tpls in blz.dataLayer.templates) {
        // eslint-disable-next-line
        if (blz.dataLayer.templates.hasOwnProperty(tpls)) {
          objs[tpls] = _objectCopy(blz.dataLayer.templates[tpls]);
        }
      }

      var pageViews = {
        BLZproductDetail: objs.BLZproductDetail.ecommerce.detail.products,
        BLZpage: objs.BLZpage
      };

      for (var i = 0; i < elements.length; i++) {
        try {
          config = JSON.parse(
            elementsData ? elementsData[i] : elements[i].getAttribute('data-layer')
          );
        } catch (o_O) {
          //
        }

        dataLayerEvent = config.event;

        if (pageViews[dataLayerEvent]) {
          // Create impression only in new elements and prevent trigger cloned carousel items
          if (
            !elementsData &&
            (elements[i].previewed || /cloned/gi.test(elements[i].parentNode.className))
          ) {
            continue;
          }
          if (dataLayerEvent === 'BLZpage') {
            dataLayer.push(objs.BLZpage);
          }

          // Set flag to prevent trigger preview double times
          if (!elementsData) {
            elements[i].previewed = true;
          }

          if (pageViews[dataLayerEvent] instanceof Array) {
            pageViews[dataLayerEvent].push(_getConfig(dataLayerEvent, config, listName));
          }
        }
      }

      // Inject pageViews objects
      for (var impression in pageViews) {
        // eslint-disable-next-line
        if (pageViews.hasOwnProperty(impression)) {
          if (pageViews[impression].length) dataLayer.push(objs[impression]);
        }
      }
    }
    //Inject banner data objects
    function _bannerImpression(banner) {
      try {
        var dataBanner = JSON.parse(banner.getAttribute('data-banner'));
        dataLayer.push({ event: 'BLZbannerImpression', bannerData: dataBanner });
      } catch (o_O) {
        //
      }
    }

    /*
     * Customer info
     */
    var me = blz.me;

    dataLayer.push({
      userid: me.id,
      'status-login': me.id ? 'logado' : 'nao-logado',
      platform: blz.globals.platform
    });

    if (me.id) {
      var purchases = (me.purchaseInfo || {}).quantity || 0;

      // TODO  remove old event
      dataLayer.push({
        event: 'BLZcustomer',
        customer: {
          id: me.id || 0,
          age: DateService.age(me.birthDate) || 0,
          socialId: me.facebookId,
          birthDate: me.birthDate,
          gender: me.gender || 0,
          purchases: purchases,
          newsletter: me.newsletter,
          cpf: me.cpf,
          nickName: me.nickName || '',
          email: me.email,
          email5: me.md5,
          email256: me.sha256,
          name: (me.givenName || '') + ' ' + (me.familyName || ''),
          givenName: me.givenName || '',
          familyName: me.familyName || '',
          addressLocality: me.addressLocality || '',
          addressRegion: me.addressRegion || '',
          createdAt: me.createdAt,
          purchaseInfo: me.purchaseInfo
        }
      });
    }

    /*
     * Private methods
     */

    function _objectCopy(input) {
      return typeof input === 'object' ? JSON.parse(JSON.stringify(input)) : input;
    }

    /*
     * Remove undefined items from object
     */
    function _removeEmptyNodes(newConfig) {
      var hasConfig = 0;
      for (var i in newConfig) {
        hasConfig++;
        if (!newConfig[i]) {
          delete newConfig[i];
          hasConfig--;
        }
      }
      return hasConfig ? newConfig : undefined;
    }

    /*
     * Return config structure
     */
    function _getConfig(dataLayerEvent, config, listName) {
      var newConfig = {},
        name = config.name && config.name.replace(/'|\r|\n|\r\n/g, ''),
        id = config.id,
        parentId = config.parentId,
        price = config.price,
        brand = config.brand && config.brand.replace(/'|\r|\n|\r\n/g, ''),
        category = config.category,
        position = config.position || '1',
        creative = config.creative,
        quantity = '' + config.quantity || '1';

      if (/product|cart/i.test(dataLayerEvent)) {
        newConfig = {
          name: name,
          id: id,
          parentId: parentId,
          price: price,
          brand: brand,
          category: category,
          quantity: quantity
        };
      }

      if (/product|cart/i.test(dataLayerEvent)) {
        newConfig.position = position;
      }

      if (listName && /productimpression/i.test(dataLayerEvent)) {
        newConfig.list = listName;
      }

      if (/promo/i.test(dataLayerEvent)) {
        newConfig = {
          name: name,
          position: position,
          creative: creative
        };
      }

      return _removeEmptyNodes(newConfig);
    }
  }
})();
